export enum EmailsComponentLocators {
	emailsNewButton = 'emailsNewButton',
	emailsSearchField = 'emailsSearchField',
	emailSerchIconButton = 'emailsSearchIconButton',
}
